// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3p1Of","content":"RecentSearches_content__3TEph"};